
module.cC({
    name: 'StudentController',
    inject: ['$scope', '$timeout', 'ModelService', 'student', 'permissions',
             'ModelConfig'],
    data: {
        permissions: 'permissions',
        student: 'student',
    },

    init: function() {
        this.$.options = this.ModelConfig.getOptions(['credential_awarded', 'credential_at_entry']);
    },

    listen: {
        all: {
            issues: '_updateStudent',
        }
    },

    computed: {
        credentialType: {
            watch: ['student.education_profile.credential_at_entry',
                    'student.education_profile.credential_awarded'],
            get: function() {
                var entry = this.student.education_profile.credential_at_entry,
                    awarded = this.student.education_profile.credential_awarded;

                return awarded || entry || 'none';
            }
        }
    },

    methods: {
        cohortName: function(cohort) {
            return (cohort - 1) + " - " + (cohort % 100);
        },
        formatCredentialType: function(type) {
            if (!this.options) return;
            if (this.options.credential_at_entry[type]) {
                return this.options.credential_at_entry[type] + " at entry";
            } else  {
                return this.options.credential_awarded[type];
            }
        },

        _updateStudent: function(name, id) {
            if (id === this.student.id) {
                this.ModelService.debouncedRelation('participant', id, 'summary')
                    .then(this.ModelService.copyInto(this.student))
            }
        },

        loadIconData: function(name) {
            return this.ModelService.getModelRelation(this.student, name, {
                per_page: 3})
        },
    }
});
